import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchStoreTrailerEta = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/inbound_trailers/store_trailers/eta_events`,
)
